import httpService from "../../services/http.service";
import { Box, Skeleton } from "@mui/material";

import React, { useEffect, useRef, useState } from "react";
import { MoviesSlider } from "./moviesList";
import { getCMSApiRoute } from "../../utils/api.utils";
import { updateAllLayouts } from "@noriginmedia/norigin-spatial-navigation";
import toast from "react-hot-toast";
import { getAgeRangePublicRoute } from "../../utils/ageRange.util";

const RelatedMovies = ({ slug, onFocus, genreKeys, categoryKeys, kind }) => {
  const [relatedMovies, setRelatedMovies] = useState(null);
  const [loading, setLoading] = useState(true);
  const initialized = useRef(false);

  const handleMovies = (movies) => {
    if (!relatedMovies) {
      setRelatedMovies(movies);
    }
  };

  const getRelatedMovies = async () => {
    try {
      const ageRange = getAgeRangePublicRoute();
      // Use first 2 genres for more relevant related content matching
      const genreParam = genreKeys?.slice(0, 2).join(',') || null;

      // Skip if no genres available
      if (!genreParam) {
        setLoading(false);
        return;
      }

      const response = await httpService.get(getCMSApiRoute("content"), {
        params: {
          pageIndex: 15,
          pageNumber: 1,
          genre: genreParam,
          kind,
          contentAgeRange: ageRange,
        },
      });

      if (response.status === 200) {
        const results = response.data?.data?.results || [];
        // Filter out the current content from related suggestions
        const filtered = results.filter((item) => item.slug !== slug);
        handleMovies(filtered);
        setLoading(false);
        updateAllLayouts();
      } else {
        toast.error(
          "خطا در هنگام دریافت لیست فیلم های مشابه، لطفا بعدا تلاش فرمائید",
          { variant: "error" }
        );
      }
    } catch (error) {
      toast.error(
        "خطا در هنگام دریافت لیست فیلم های مشابه، لطفا بعدا تلاش فرمائید",
        { variant: "error" }
      );
    }
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      if (!slug) return;
      getRelatedMovies();
    }
  }, []);

  if (loading) {
    return (
      <Box
        display={"flex"}
        width={"90%"}
        mx={"auto"}
        position={"relative"}
        overflow={"hidden"}
        gap={2}
        flexWrap={"nowrap"}
        sx={{
          "&::after": {
            content: `""`,
            position: "absolute",
            width: "150px",
            height: "100%",
            background: "linear-gradient(to right, #121212, rgba(0, 0, 0, 0))",
            left: -5,
            top: 0,
          },
        }}
      >
        {[1, 2, 3, 4, 5, 6]?.map((item) => (
          <Skeleton
            variant="rectangular"
            width={215}
            height={300}
            key={"skeleton" + item}
            sx={{
              borderRadius: "20px",
              bgcolor: "#333333",
              minWidth: "215px",
              marginLeft: "20px",
            }}
          />
        ))}
      </Box>
    );
  } else {
    return (
      <MoviesSlider
        title={"فیلم های مشابه"}
        movies={relatedMovies}
        onFocus={onFocus}
      />
    );
  }
};

export default RelatedMovies;
